export default __webpack_public_path__ + "static/media/SEC3040.34I-41328_-24650_0.bccac258.jpg";